module.exports = __webpack_public_path__ + "static/media/5H.3a5059d0.svg";